import { render, staticRenderFns } from "./VocabularyList.vue?vue&type=template&id=c2b55d04&"
import script from "./VocabularyList.vue?vue&type=script&lang=js&"
export * from "./VocabularyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports